import { AHListItem, AHSeparator, AHText, Box, useTheme } from "arkh";
import {
  ActivityIndicator,
  FlatList,
  FlatListProps,
  Platform,
  View,
} from "react-native";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { HeaderButton } from "../../components";

import { keyExtractorId } from "../../common/keyExtractors";
import { Header } from "@react-navigation/elements";

function RoutineOccasionsHistoryListEmpty() {
  return (
    <AHListItem
      isTopItem
      isBottomItem
      style={[
        {
          alignItems: "center",
        },
      ]}
    >
      <View
        style={{
          flexDirection: "row",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AHText type="subtitle">
          <FormattedMessage
            defaultMessage="This checklist has no history yet"
            description="RoutineOccasionHistoryScreen: No History"
          />
        </AHText>
      </View>
    </AHListItem>
  );
}

function RoutineOccasionsHistoryListFooter(props: { isLoadingNext: boolean }) {
  return (
    <>
      <AHSeparator />
      {props.isLoadingNext ? (
        <View
          style={[
            {
              alignItems: "center",
              height: 75,
            },
          ]}
        >
          <View
            style={{
              flexDirection: "column",
              flex: 1,
              alignItems: "center",
              justifyContent: "space-evenly",
              marginHorizontal: 5,
              width: 100,
            }}
          >
            <AHText type="body">
              <FormattedMessage
                defaultMessage="Loading history"
                description="RoutineOccasionHistoryScreen:Loading"
              />
            </AHText>
            <ActivityIndicator animating />
          </View>
        </View>
      ) : null}
      <View style={{ height: 20 }} />
    </>
  );
}

export function RoutineOccasionHistoryListComponent<
  T extends { sequenceNumber: number; id: string },
>(props: {
  onClose: () => void;
  isLoadingNext: boolean;
  hasNext: boolean;
  loadNext: (count: number) => void;
  occasions: T[];
  getItemLayout: FlatListProps<T>["getItemLayout"];
  renderItem: FlatListProps<T>["renderItem"];
}) {
  const theme = useTheme();

  const intl = useIntl();
  const title = intl.formatMessage({
    defaultMessage: "All Occasions",
    description: "RoutineOccasionHistoryScreen: All Occasions title",
  });
  return (
    <Box style={{ flex: 1 }} color="surface-background-light">
      <Box>
        <Header
          headerStyle={{
            backgroundColor: theme.surface,
          }}
          headerShadowVisible={false}
          title={title}
          headerRight={() => (
            <Box spaceRight={Platform.OS === "web" ? "none" : "medium"}>
              <HeaderButton type="CLOSE" onPress={props.onClose} />
            </Box>
          )}
        />
        <AHSeparator />
      </Box>

      <FlatList
        maintainVisibleContentPosition={{ minIndexForVisible: 0 }}
        contentInsetAdjustmentBehavior="automatic"
        keyExtractor={keyExtractorId}
        data={props.occasions}
        getItemLayout={props.getItemLayout}
        ListEmptyComponent={RoutineOccasionsHistoryListEmpty}
        ItemSeparatorComponent={AHSeparator}
        ListFooterComponent={() => (
          <RoutineOccasionsHistoryListFooter
            isLoadingNext={props.isLoadingNext}
          />
        )}
        onEndReached={() => {
          if (!props.isLoadingNext && props.hasNext) {
            props.loadNext(15);
          }
        }}
        renderItem={props.renderItem}
      />
    </Box>
  );
}
